import postReadMoreView from './postReadMoreComponent.html';
import { VideoPlayerYoutube } from 'components/sharpr/videoPlayer/youtube/VideoPlayerYoutube';
import { VideoPlayerVimeo } from 'components/sharpr/videoPlayer/vimeo/VideoPlayerVimeo';
import { AuthTypes } from 'components/sharpr/auth/AuthTypes';

export function postReadMoreComponent() {
	return {
		bindings: {
			post: '<',
			isMinimal: '<?',
		},
		controllerAs: 'vm',
		controller: postReadMoreComponentCtrl,
		template: postReadMoreView,
	};
}

export class postReadMoreComponentCtrl {
	constructor(Api, EventTracker) {
		'ngInject';
		this.Api = Api;
		this.EventTracker = EventTracker;
	}

	markAsViewed() {
		this.EventTracker.save('click_source', {
			post_id: this.post.id,
			url: this.post.source_link,
		});
		//We want clicking ot the source to also count as a post view
		const source = document.title.replace(' :: Sharpr', '');
		this.EventTracker.save('post_view', {
			post_id: this.post.id,
			source,
		});
		// if we are at a story board, also record view in story_board_clicks table
		if (AuthTypes.getBoardHash()) {
			this.Api.post(`/story_boards/${AuthTypes.getBoardHash()}/click`, { post_id: this.post.id });
		}
	}

	getText() {
		this.link = this.post.source_link;
		let txt = '';

		if (this.post.read_more_text) {
			txt = this.post.read_more_text;
		} else if (!this.post.source_link) {
			this.link = window.isMobile ? '#/post/detail/' + this.post.id : '/p/' + this.post.id;
			txt = 'View details';
		} else if (VideoPlayerYoutube.isPlayable(this.post.source_link)) {
			txt = 'Watch on YouTube';
		} else if (VideoPlayerVimeo.isPlayable(this.post.source_link)) {
			txt = 'Watch on Vimeo';
		} else if (this.post.source_name) {
			txt = 'Read more at ' + this.post.source_name;
			if (this.isMinimal) {
				txt = this.post.source_name;
			}
		} else {
			let domain = this.post.source_link.replace(/^https?:\/\/([^/]+).*/i, '$1').replace(/^www\./i, '');
			txt = 'Read more at ' + domain;

			if (this.isMinimal) {
				txt = domain;
			}
		}

		return txt;
	}
}
